// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.auth.HpApiAuthenticationV3Handler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiAuthenticationV3Handler_apple,
  HpApiAuthenticationV3Handler_freepass,
  HpApiAuthenticationV3Handler_google,
  HpApiAuthenticationV3Handler_logout,
  HpApiAuthenticationV3Handler_otp,
  HpApiAuthenticationV3Handler_sendOtp,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpAppleAuthRequestDto,
  HpFreepassAuthRequestDto,
  HpGoogleAuthRequestDto,
  HpOtpSendAuthRequestDto,
  HpOtpVerifyAuthRequestDto,
  HpUserCredentialsDto,
} from '@zg-rentals/ts-hotpads-api-client';

export interface HpApiAuthenticationV3Handler_apple_Args {
  postData: HpAppleAuthRequestDto;
}

export type HpApiAuthenticationV3Handler_apple_Options = UseMutationOptions<
  HpApiResponseDto<HpUserCredentialsDto>,
  unknown,
  HpApiAuthenticationV3Handler_apple_Args
>;

/**
 * Sign in with an Apple ID token
 */
export const useHpApiAuthenticationV3Handler_apple = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_apple_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiAuthenticationV3Handler_apple_Args) =>
      HpApiAuthenticationV3Handler_apple(args.postData, httpClient),
  });
};

export interface HpApiAuthenticationV3Handler_freepass_Args {
  postData: HpFreepassAuthRequestDto;
}

export type HpApiAuthenticationV3Handler_freepass_Options = UseMutationOptions<
  HpApiResponseDto<HpUserCredentialsDto>,
  unknown,
  HpApiAuthenticationV3Handler_freepass_Args
>;

/**
 * Redeem a freepass email-link token
 */
export const useHpApiAuthenticationV3Handler_freepass = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_freepass_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiAuthenticationV3Handler_freepass_Args) =>
      HpApiAuthenticationV3Handler_freepass(args.postData, httpClient),
  });
};

export interface HpApiAuthenticationV3Handler_google_Args {
  postData: HpGoogleAuthRequestDto;
}

export type HpApiAuthenticationV3Handler_google_Options = UseMutationOptions<
  HpApiResponseDto<HpUserCredentialsDto>,
  unknown,
  HpApiAuthenticationV3Handler_google_Args
>;

/**
 * Sign in with a Google ID token
 */
export const useHpApiAuthenticationV3Handler_google = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_google_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiAuthenticationV3Handler_google_Args) =>
      HpApiAuthenticationV3Handler_google(args.postData, httpClient),
  });
};

export type HpApiAuthenticationV3Handler_logout_Options = UseMutationOptions<HpApiResponseDto<boolean>, unknown, void>;

/**
 * Log out: clear session cookies and reset to an anonymous session
 */
export const useHpApiAuthenticationV3Handler_logout = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_logout_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => HpApiAuthenticationV3Handler_logout(httpClient),
  });
};

export interface HpApiAuthenticationV3Handler_otp_Args {
  postData: HpOtpVerifyAuthRequestDto;
}

export type HpApiAuthenticationV3Handler_otp_Options = UseMutationOptions<
  HpApiResponseDto<HpUserCredentialsDto>,
  unknown,
  HpApiAuthenticationV3Handler_otp_Args
>;

/**
 * Redeem a one-time sign-in code
 */
export const useHpApiAuthenticationV3Handler_otp = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_otp_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiAuthenticationV3Handler_otp_Args) =>
      HpApiAuthenticationV3Handler_otp(args.postData, httpClient),
  });
};

export interface HpApiAuthenticationV3Handler_sendOtp_Args {
  postData: HpOtpSendAuthRequestDto;
}

export type HpApiAuthenticationV3Handler_sendOtp_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiAuthenticationV3Handler_sendOtp_Args
>;

/**
 * Send a one-time sign-in code email
 */
export const useHpApiAuthenticationV3Handler_sendOtp = ({
  httpClient,
  ...options
}: Omit<HpApiAuthenticationV3Handler_sendOtp_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiAuthenticationV3Handler_sendOtp_Args) =>
      HpApiAuthenticationV3Handler_sendOtp(args.postData, httpClient),
  });
};
